
import FormattedImage from '~/components/common/FormattedImage';
import imagePlaceholder from '~/assets/images/project/stub_card_detail_invest.svg'

const IMAGE_PLACEHOLDER = imagePlaceholder

export default {
    methods: {
        setActiveCollateral() {
            this.$emit('setActiveCollateral', this.collateral);
        }
    },
    computed: {
        oisPreviewImage() {
            return this.collateral?.contents?.images?.cover_613x345.download_id
                ? this.serverImage(this.collateral.contents.images.cover_613x345.download_id)
                : IMAGE_PLACEHOLDER;
        },
    },
    props: {
        collateral: {
            type: Object
        },
        index: {
            type: Number
        }
    },
    components: {
        FormattedImage
    }
}
